document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nvu-detail-tabs').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[role="tab"]')];
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => {
        const selected = item === button;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !selected;
      });
    }));
  });
  document.querySelectorAll('[data-nvu-submit]').forEach((button) => button.addEventListener('click', () => {
    document.querySelector(`#product-form-${button.dataset.nvuSubmit} [type="submit"]`)?.click();
  }));
});
